export default {
    NORMAL: 1,
    ALTERADO: 2,
    SUGESTIVO_DE_INFECCAO_CONGENITA: 3,
    OUTRAS_ALTERACOES: 4,
    INDETERMINADO: 5,
    FALHOU: 6,
    PASSOU: 7,
}